<template>
  <div class="relative">
    <div
      class="skill_box is-flex is-align-items-center is-justify-content-center"
      :class="{ 'is-revoked': is_revoked }"
    >
      <div class="is-flex">
        <div class="dropdown" :class="isEditingComment ? 'is-active' : ''">
          <div class="dropdown-trigger">
            <button class="button is-small mx-1" :class="{ 'is-warning': applicant_skill.applicant_comment }" @click="toggleCommentEdit">
              <span>C</span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu5" role="menu">
            <div class="dropdown-content">
              <div class="dropdown-item">
                <textarea
                  v-model="currentComment"
                  class="textarea is-small"
                  rows="10"
                  style="width: 300px;"
                ></textarea>
                <div class="buttons my-2">
                  <button class="button is-small is-success" @click="saveComment">שמור</button>
                  <button class="button is-small mx-2" @click="cancelEdit">ביטול</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <IsApproved :applicantId="applicant_id" :applicantSkill="applicant_skill" @updated="notifyParent"/>
        <button
          class="button is-small mx-1"
          :class="{ 'is-success': applicant_skill.has_experience === true }"
          @click="setHasExperience(true)"
        >Y</button>
        <button
          class="button is-small"
          :class="{ 'is-danger': applicant_skill.has_experience === false }"
          @click="setHasExperience(false)"
        >N</button>
      </div>
      <div class="is-flex is-align-items-center" :class="{ 'has-background-info': classBlue }">
        <p class="m-0 mx-1">{{ applicant_skill.skill.name }}</p>
      </div>

    </div>
  </div>
</template>
<script>
import IsApproved from '../../entities/applicantSkill/IsApproved.vue'

export default {
  name: 'applicant-skill',
  components: {
    IsApproved
  },
  props: ['applicant_id', 'applicant_skill', 'classBlue', 'inputType'],
  data () {
    return {
      is_loading: false,
      isEditingComment: false,
      currentComment: ''
    }
  },
  computed: {
    is_revoked () {
      return this.applicant_skill.details == undefined ? false : this.applicant_skill.details.revoked
    },
    hasComment () {
      return !!this.applicant_comment
    }
  },
  methods: {
    setHasExperience (value) {
      this.serverCall('updateApplicantSkill', value ? 'set_has_exp' : 'set_no_exp', {
        has_experience: value
      })
    },
    async serverCall (method, action, params) {
      this.is_loading = true
      await this.$network_utils[method]({
        id: this.applicant_skill.id,
        current_applicant_id: this.applicant_id,
        ...params
      })
      this.notifyParent(action, this)
      this.is_loading = false
    },
    notifyParent (action, skill) {
      this.$emit('refresh', { action, skill })
    },
    toggleCommentEdit () {
      this.isEditingComment = !this.isEditingComment
      this.currentComment = this.applicant_skill.applicant_comment || ''
    },
    async saveComment () {
      this.is_loading = true
      await this.serverCall('updateApplicantSkill', 'update_comment', {
        applicant_comment: this.currentComment
      })
      this.applicant_skill.applicant_comment = this.currentComment
      this.isEditingComment = false
      this.is_loading = false
    },
    cancelEdit () {
      this.isEditingComment = false
      this.currentComment = ''
    }
  }
}
</script>
